import * as React from 'react';

import './Footer.css';

class Footer extends React.Component {
	render() {
		return (
			<section className="footer">
				<div className="seperator">&nbsp;</div>
				<div className="logo">
					<img id="logo" src="/hcs-company.svg" alt="HCS company" />
				</div>
			</section>
		);
	}
}

export default Footer;
